import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateLeadCustomFieldValue as UpdateLeadCustomFieldValueMutation,
    UpdateLeadCustomFieldValueVariables,
    UpdateLeadInputFieldInput,
} from 'nutshell-graphql-types';

import UPDATE_LEAD_CUSTOM_FIELD_VALUE from '../mutations/update-lead-custom-field-value.graphql';

export const useUpdateLeadCustomFieldValue = (): {
    updateLeadCustomFieldValue: (arg1: UpdateLeadInputFieldInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateLeadCustomFieldValue, {loading, error}] = useMutation<
        UpdateLeadCustomFieldValueMutation,
        UpdateLeadCustomFieldValueVariables
    >(UPDATE_LEAD_CUSTOM_FIELD_VALUE);

    return {
        updateLeadCustomFieldValue: (lead: UpdateLeadInputFieldInput) =>
            updateLeadCustomFieldValue({
                variables: {lead},
                refetchQueries: ['GetTopCustomFields', 'GetWidgetCustomFields'],
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
